import { ChangeDetectionStrategy, Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { IParametre, ITurParametre } from '../../../../interfaces/IParametre/IParametre';
import { HAZIR_PARAMETRE_SETLERI, IHazirSet } from '../hazir-setler/hazir-setler';

/** Hizli tur tanimi */
interface IHizliTur {
  turu: ITurParametre;
  simge: string;
  etiket: string;
  aciklama?: string;
}

@Component({
  selector: 'parametre-hizli-ekle',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzIconModule,
    NzInputModule,
    NzDropdownModule,
    NzMenuModule,
    NzTooltipModule,
    NzTagModule
  ],
  templateUrl: './parametre-hizli-ekle.component.html',
  styleUrls: ['./parametre-hizli-ekle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParametreHizliEkleComponent {
  @Output() parametreEklendi = new EventEmitter<IParametre>();
  @Output() setEklendi = new EventEmitter<IParametre[]>();
  @Input() mevcutIsimler: string[] = [];

  /** Secilen tur */
  secilenTur: IHizliTur | null = null;

  /** Parametre ismi girisi */
  parametreIsmi = '';

  /** Panel acik mi */
  panelAcik = false;

  /** Tum turler dropdown acik mi */
  tumTurlerAcik = false;

  /** Sik kullanilan turler (hep gorunur) */
  sikKullanilanTurler: IHizliTur[] = [
    { turu: 'Yazı', simge: 'font-size', etiket: 'Yazı' },
    { turu: 'Sayı', simge: 'number', etiket: 'Sayı' },
    { turu: 'Tarih', simge: 'calendar', etiket: 'Tarih' },
    { turu: 'Açılır Kutu', simge: 'down-square', etiket: 'Liste' },
    { turu: 'Onay', simge: 'check-square', etiket: 'Onay' },
  ];

  /** Tum turler (dropdown icin) */
  tumTurler: IHizliTur[] = [
    // Metin
    { turu: 'Yazı', simge: 'font-size', etiket: 'Yazı', aciklama: 'Kisa metin' },
    { turu: 'Yazı Alanı', simge: 'align-left', etiket: 'Yazı Alanı', aciklama: 'Uzun metin' },
    { turu: 'Parola', simge: 'lock', etiket: 'Parola', aciklama: 'Gizli metin' },
    { turu: 'RichText', simge: 'bold', etiket: 'RichText', aciklama: 'Zengin metin' },
    { turu: 'Kod', simge: 'code', etiket: 'Kod', aciklama: 'Kod editoru' },
    // Sayisal
    { turu: 'Sayı', simge: 'number', etiket: 'Sayı', aciklama: 'Sayi girisi' },
    { turu: 'Para', simge: 'dollar', etiket: 'Para', aciklama: 'Para birimi' },
    { turu: 'XYZ', simge: 'aim', etiket: 'XYZ', aciklama: '3D koordinat' },
    // Tarih/Saat
    { turu: 'Tarih', simge: 'calendar', etiket: 'Tarih', aciklama: 'Tarih secici' },
    { turu: 'Tarih Saat', simge: 'field-time', etiket: 'Tarih Saat', aciklama: 'Tarih + saat' },
    { turu: 'Saat', simge: 'clock-circle', etiket: 'Saat', aciklama: 'Saat secici' },
    { turu: 'Zaman Aralığı', simge: 'swap', etiket: 'Zaman Aralığı', aciklama: 'Baslangic-bitis' },
    // Secim
    { turu: 'Açılır Kutu', simge: 'down-square', etiket: 'Açılır Kutu', aciklama: 'Dropdown liste' },
    { turu: 'Onay', simge: 'check-square', etiket: 'Onay', aciklama: 'Checkbox' },
    { turu: 'Anahtar', simge: 'swap', etiket: 'Anahtar', aciklama: 'Toggle switch' },
    { turu: 'Doğruluk', simge: 'question-circle', etiket: 'Doğruluk', aciklama: 'Dogru/Yanlis/Bilinmiyor' },
    { turu: 'Oylama', simge: 'star', etiket: 'Oylama', aciklama: 'Yildiz/oy' },
    // Medya
    { turu: 'Resim', simge: 'picture', etiket: 'Resim', aciklama: 'Gorsel yukle' },
    { turu: 'Video', simge: 'video-camera', etiket: 'Video', aciklama: 'Video yukle' },
    { turu: 'Ses', simge: 'audio', etiket: 'Ses', aciklama: 'Ses yukle' },
    { turu: 'Dosya', simge: 'file', etiket: 'Dosya', aciklama: 'Dosya yukle' },
    { turu: 'Dosya Yükleme', simge: 'upload', etiket: 'Dosya Yükleme', aciklama: 'Surukle birak yukle' },
    // Ozel
    { turu: 'Renk', simge: 'bg-colors', etiket: 'Renk', aciklama: 'Renk secici' },
    { turu: 'Konum', simge: 'environment', etiket: 'Konum', aciklama: 'GPS konum' },
    { turu: 'İmza', simge: 'edit', etiket: 'İmza', aciklama: 'El yazisi imza' },
    { turu: 'KareKod', simge: 'qrcode', etiket: 'QR Kod', aciklama: 'QR kod uret' },
    { turu: 'BarKod', simge: 'barcode', etiket: 'Barkod', aciklama: 'Barkod' },
    { turu: 'İlerleme Çubuğu', simge: 'loading', etiket: 'İlerleme', aciklama: 'Yuzdeli cubuk' },
    // Yapi
    { turu: 'Grup', simge: 'group', etiket: 'Grup', aciklama: 'Parametre grubu' },
    { turu: 'Sekme', simge: 'folder', etiket: 'Sekme', aciklama: 'Sekmeli yapi' },
    { turu: '2liSatır', simge: 'column-width', etiket: '2li Satır', aciklama: '2 kolon yapi' },
    { turu: '3lüSatır', simge: 'column-width', etiket: '3lü Satır', aciklama: '3 kolon yapi' },
    { turu: 'Simgeli Başlık', simge: 'tag', etiket: 'Başlık', aciklama: 'Simgeli baslik' },
    { turu: 'Liste', simge: 'unordered-list', etiket: 'Liste', aciklama: 'Liste yapisi' },
    { turu: 'Tablo', simge: 'table', etiket: 'Tablo', aciklama: 'Tablo yapisi' },
    { turu: 'Dinamik Bileşen', simge: 'appstore', etiket: 'Dinamik Bileşen', aciklama: 'Harici bilesen yukle' },
    { turu: 'Dosya Kutusu', simge: 'folder-open', etiket: 'Dosya Kutusu', aciklama: 'Klasörlü dosya yönetimi' },
  ];

  /** Hizli tur tikla */
  turSec(tur: IHizliTur) {
    this.secilenTur = tur;
    this.panelAcik = true;
    this.parametreIsmi = '';
    // ismi input'una focus
    setTimeout(() => {
      const input = document.querySelector('.hizli-ekle-isim-input') as HTMLInputElement;
      input?.focus();
    }, 50);
  }

  /** Tum turlerden sec */
  tumTurlerdenSec(tur: IHizliTur) {
    this.tumTurlerAcik = false;
    this.turSec(tur);
  }

  /** Enter ile ekle */
  enterIleEkle() {
    if (!this.parametreIsmi?.trim() || !this.secilenTur) return;

    const ismi = this.parametreIsmi.trim()
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9_çğışöüÇĞİŞÖÜ]/g, '');

    if (!ismi) return;

    // Benzersizlik kontrolu
    if (this.mevcutIsimler.includes(ismi)) {
      return; // Zaten var
    }

    const yeniParametre: IParametre = {
      turu: this.secilenTur.turu,
      ismi: ismi,
      baslik: this.parametreIsmi.trim(),
      degeri: null,
      ayarlar: {},
      kontroller: [],
      hatalar: [],
      uyarilar: []
    };

    this.parametreEklendi.emit(yeniParametre);

    // Sifirla - panel acik kalsin, ayni turde devam edebilsin
    this.parametreIsmi = '';
    setTimeout(() => {
      const input = document.querySelector('.hizli-ekle-isim-input') as HTMLInputElement;
      input?.focus();
    }, 50);
  }

  /** Paneli kapat */
  paneliKapat() {
    this.panelAcik = false;
    this.secilenTur = null;
    this.parametreIsmi = '';
  }

  /** Escape ile kapat */
  escIleKapat(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.paneliKapat();
    }
  }

  /** Hazır set dropdown açık mı */
  hazirSetlerAcik = false;

  /** Hazır parametre setleri */
  hazirSetler: IHazirSet[] = HAZIR_PARAMETRE_SETLERI;

  /** Hazır set ekle */
  hazirSetEkle(set: IHazirSet) {
    this.hazirSetlerAcik = false;
    const parametreler = set.parametreler.map(p => JSON.parse(JSON.stringify(p)) as IParametre);
    this.setEklendi.emit(parametreler);
  }
}
